module.exports = __webpack_public_path__ + "static/media/banner-home-3.85bedff5.jpg";